module.exports = __webpack_public_path__ + "static/media/Community5.fffce43a.png";